import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HashtagRoutingService {
  public normalizeSlug(value: string | null | undefined): string {
    return (value || '')
      .trim()
      .replace(/^#+/, '')
      .toLowerCase();
  }

  public buildTagPath(slug: string | null | undefined): string {
    const normalized = this.normalizeSlug(slug);
    return normalized ? `/tags/${normalized}` : '/search-results';
  }

  public buildTagQuery(slug: string | null | undefined): string {
    const normalized = this.normalizeSlug(slug);
    return normalized ? `#${normalized}` : '';
  }

  public isTagQuery(query: string | null | undefined): boolean {
    return /^#?[\p{L}\p{N}_-]{2,64}$/u.test((query || '').trim());
  }

  public isExplicitTagQuery(query: string | null | undefined): boolean {
    return /^#[\p{L}\p{N}_-]{2,64}$/u.test((query || '').trim());
  }
}
